import React from "react";
import type { CopyUrlFieldProps } from "./CopyUrlField.types";
import { CopyButton, Field, Row } from "./CopyUrlField.styles";

/** A single-line read-only URL box with a Copy button beside it. */
export const CopyUrlField: React.FC<CopyUrlFieldProps> = ({ url, ariaLabel, copyLabel, copiedLabel, copied, onCopy, className }) => (
  <Row className={className}>
    <Field readOnly value={url ?? ""} aria-label={ariaLabel} onFocus={(e) => e.currentTarget.select()} />
    <CopyButton variant="primary" size="md" onClick={onCopy} disabled={!url}>
      {copied ? copiedLabel : copyLabel}
    </CopyButton>
  </Row>
);

export default CopyUrlField;
